import React from 'react';
import PropTypes from 'prop-types';
import {
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import ErrorBoundary from './ErrorBoundary';

const VideoPlayerModal = ({ handleClose, title, url }) => (
  <ErrorBoundary>
    <ModalHeader toggle={handleClose}>
      {title && title}
    </ModalHeader>
    <ModalBody>
      <iframe
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          overflow: 'hidden',
        }}
        frameBorder="0"
        type="text/html"
        src={url}
        width="100%"
        height="100%"
        allowFullScreen
        title={title || null}
      />
    </ModalBody>
  </ErrorBoundary>
);

VideoPlayerModal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

VideoPlayerModal.defaultProps = {
  title: null,
};

export default VideoPlayerModal;
